import { render, staticRenderFns } from "./WHr.vue?vue&type=template&id=70ac7834&scoped=true&"
import script from "./wHr.ts?vue&type=script&lang=ts&"
export * from "./wHr.ts?vue&type=script&lang=ts&"
import style0 from "./WHr.vue?vue&type=style&index=0&id=70ac7834&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ac7834",
  null
  
)

export default component.exports